module.exports = __webpack_public_path__ + "static/media/Loki 3.ea10bd22.jpg";